module.exports = __webpack_public_path__ + "static/secretSiteImage-4d7cfbe439bd893c5bd2fb5e1e0f0182.png";